import { chartColors, chartColumnFade, chartCrosshair } from './ChartColors'

export { chartColors }

// Le um token de src/utils/styles/theme.scss ja resolvido para o tema atual.
// O Highcharts desenha em SVG com cor literal, entao nao entende `var(--token)`.
export function chartToken(name:string):string {
    try {
        return getComputedStyle(document.documentElement).getPropertyValue(name).trim()
    } catch (e) {
        return ''
    }
}

// Escala do mapa de calor (pico de vendas), do vazio ao pico
export function chartHeatStops():Array<[number, string]> {
    return [
        [0, chartToken('--chart-heat-0')],
        [0.35, chartToken('--chart-heat-1')],
        [0.7, chartToken('--chart-heat-2')],
        [1, chartToken('--chart-heat-3')],
    ]
}

// Opcoes do Highcharts que dependem do tema. Montada de novo a cada troca de tema
// (ver ChartThemeService) - por isso e funcao, e nao constante.
export function buildChartTheme():any {
    const textColor = chartToken('--chart-text')
    const mutedTextColor = chartToken('--chart-muted')
    const lineColor = chartToken('--chart-line')
    const surface = chartToken('--chart-bg')
    const overlay = chartToken('--surface-overlay')
    const legendColor = chartToken('--chart-legend')

    return {
        colors: chartColors,
        lang: {
            decimalPoint: ',',
            loading: 'Carregando...',
            noData: 'Sem informações',
        },
        chart: {
            backgroundColor: 'transparent',
            style: {
                fontFamily: `'Source Sans Pro', sans-serif`,
            },
        },
        title: {
            style: {
                color: textColor,
                fontSize: '14px',
            },
        },
        loading: {
            labelStyle: {
                color: mutedTextColor,
                fontWeight: '600',
                top: '45%',
            },
            style: {
                backgroundColor: surface,
                opacity: 0.7,
            },
        },
        tooltip: {
            backgroundColor: overlay,
            borderWidth: 0,
            borderRadius: 10,
            padding: 12,
            shadow: {
                color: chartToken('--shadow-ink'),
                offsetX: 0,
                offsetY: 4,
                opacity: 0.08,
                width: 12,
            },
            style: {
                color: textColor,
                fontSize: '13px',
            },
        },
        legend: {
            itemStyle: {
                color: legendColor,
                fontSize: '13px',
                fontWeight: '500',
            },
            itemHoverStyle: {
                color: textColor,
            },
            symbolRadius: 6,
            symbolHeight: 10,
            symbolWidth: 10,
        },
        xAxis: {
            lineColor,
            tickLength: 0,
            labels: {
                style: {
                    color: mutedTextColor,
                    fontSize: '12px',
                },
            },
            crosshair: {
                color: chartCrosshair,
            },
        },
        yAxis: {
            labels: {
                style: {
                    color: mutedTextColor,
                    fontSize: '12px',
                },
            },
        },
        // Sem `colorAxis` aqui: no setOptions global ele cria um eixo de cor em TODO grafico
        // (as colunas passam a ser coloridas pelo valor). Quem usa (mapa de calor) declara o
        // proprio, e o ChartThemeService so recolore os que ja existem.
        plotOptions: {
            column: {
                borderRadius: 4,
                borderWidth: 0,
                pointPadding: 0.08,
                groupPadding: 0.12,
                color: {
                    linearGradient: {x1: 0, y1: 0, x2: 0, y2: 1},
                    stops: [
                        [0, chartColors[0]],
                        [1, chartColumnFade],
                    ],
                },
                states: {
                    hover: {
                        brightness: 0.08,
                    },
                },
            },
            line: {
                lineWidth: 2,
                dashStyle: 'ShortDash',
                marker: {
                    enabled: false,
                    radius: 3,
                },
                states: {
                    hover: {
                        lineWidth: 2,
                    },
                },
            },
            pie: {
                borderWidth: 2,
                borderColor: surface,
                dataLabels: {
                    style: {
                        color: textColor,
                    },
                },
                states: {
                    hover: {
                        brightness: 0.05,
                        halo: {
                            size: 6,
                            opacity: 0.15,
                        },
                    },
                },
            },
            treemap: {
                borderColor: surface,
                borderWidth: 2,
                dataLabels: {
                    style: {
                        // rotulo sobre o bloco colorido da serie: branco nos dois temas
                        color: chartToken('--white'),
                        fontSize: '13px',
                        fontWeight: '600',
                        textOutline: 'none',
                    },
                },
                drillUpButton: {
                    theme: {
                        fill: surface,
                        stroke: lineColor,
                        r: 8,
                        padding: 6,
                        style: {
                            color: textColor,
                            fontWeight: '600',
                        },
                        states: {
                            hover: {
                                fill: chartToken('--surface-3'),
                            },
                        },
                    },
                },
            },
            heatmap: {
                borderColor: surface,
                borderWidth: 3,
                dataLabels: {
                    color: textColor,
                    style: {
                        fontSize: '11px',
                        fontWeight: '600',
                        textOutline: 'none',
                    },
                },
            },
        },
    }
}
